import { BorrowerParticipants } from '../../../pages/Participants/Borrowers';
import { BaseRateTypes, Guid } from '../../models';

export * from './useDealQuery';
export * from './useIntegrationConfigQuery';
export * from './useDealRequestAllocationQuery';
export * from './useDealMatchingTranchesQuery';
export * from './useDealMatchingStatsQuery';
export * from './useCurrentUserQuery';
export * from './useDataRoomQuery';
export * from './useOtherActiveDealsQuery';
export * from './useDataRoomActivityLogQuery';
export * from './useDataRoomSummaryQuery';
export * from './useDataRoomConfirmationQuery';
export * from './useDataRoomDiligenceRequestsQuery';
export * from './useLenderDiligenceRequestsQuery';
export * from './useDataRoomDiligenceRequestUploadsQuery';
export * from './useDataRoomUserOptOutDetailsQuery';
export * from './useDataRoomAccessLogsQuery';
export * from './useOutputAnalysisStructureQuery';
export * from './useBankActionsTakenQuery';
export * from './useDealTypePreferenceQuery';
export * from './useUserControlledObjectsQuery';
export * from './useDataRoomTeasersQuery';
export * from './useDataRoomTeaserPreviewQuery';
export * from './useDataRoomTeasersQuery';
export * from './useLenderDeclineReasonsQuery';
export * from './useMatchingParamsQuery';
export * from './useActiveDataRoomUsersQuery';
export * from './useDataRoomUsersQuery';
export * from './useBankContactTeamMembersQuery';
export * from './useDataRoomDocumentsQuery';
export * from './useDownloadRequestQuery';
export * from './useDocumentDownloadHistoryQuery';
export * from './useDataRoomDocumentFoldersQuery';
export * from './useDataRoomFolderHierarchyQuery';
export * from './useSendDocumentLinkQuery';
export * from './useSendFolderLinkQuery';
export * from './useShowDeletedDocumentsQuery';
export * from './useShowAllDocumentsQuery';
export * from './useDataRoomNotesQuery';
export * from './useActiveDataRoomLendersQuery';
export * from './useLenderTermSheetRevisionsQuery';
export * from './useTermSheetComparisonQuery';
export * from './useGetTermSheetQuery';
export * from './useGetTermSheetRevisionQuery';
export * from './useGetDataRoomUserByUserQuery';
export * from './useCompanyContactDataRoomQuery';
export * from './useDataRoomTermSheetsQuery';
export * from './useLenderSummaryReportQuery';
export * from './useActiveLenderSummaryReportQuery';
export * from './useMatchingQuery';
export * from './useTermSheetRevisionMatchingParamsQuery';
export * from './useTermSheetRevisionsQuery';
export * from './useGetHistoricalBankRateQuery';
export * from './useDealProductQuery';
export * from './useIsMatchingProcessingQuery';
export * from './useFinancialCovenantTypesQuery';
export * from './useTermSheetFacilityFeesQuery';
export * from './useTermSheetFacilityCollateralQuery';
export * from './useLenderInviteModelQuery';
export * from './useMatchingTermSheetFacilitiesQuery';
export * from './useDataRoomCallQuery';
export * from './useTimezonesQuery';
export * from './useTermSheetFeesQuery';
export * from './useDataRoomLenderCallQuery';
export * from './useDataRoomMilestoneQuery';
export * from './useDataRoomLenderMilestoneQuery';
export * from './useDataRoomDirectConnectMilestoneQuery';
export * from './useDataRoomLenderDirectConnectMilestoneQuery';
export * from './useDealRequestAllocationRealEstatesQuery';
export * from './useDebtScheduleQuery';
export * from './useDataRoomLenderEmailQuery';
export * from './useLoanApplicationQuery';
export * from './useSignedNdaQuery';
export * from './useActiveNdaQuery';
export * from './useDataRoomAccessQuery';
export * from './useLenderDataRoomUserQuery';
export * from './useTransactionManagersQuery';
export * from './useSecondaryTransactionManagersQuery';
export * from './useLenderRelationsManagersQuery';
export * from './useDataRoomTeamMembersQuery';
export * from './useDataRoomTeamMemberQuery';
export * from './useBankDealProfileQuery';
export * from './useExcludedLendersQuery';
export * from './useBankDealProfileFromContactQuery';
export * from './useConditionTypesQuery';
export * from './useApplicationSettingsQuery';
export * from './useDataRoomBorrowerParticipantsQuery';
export * from './useRelatedDealsQuery';
export * from './useTeamMemberForDataRoomQuery';
export * from './useGetDataRoomUserByUserQuery';
export * from './useSalesRepsQuery';
export * from './useDirectConnectLenderInvitesQuery';
export * from './useMatchingUnavailableReasonsQuery';

export const QueryKeys = {
	CurrentUser: (authToken: string) => ['Current User', authToken],
	IsDataRoomTeamMember: (authToken: string, dataRoomGuid: Guid | null) => [
		'Is Data Room Team Member',
		authToken,
		dataRoomGuid,
	],
	Users: {
		TransactionManagers: ['TransactionManagers'],
		SalesReps: ['SalesReps'],
		SecondaryTransactionManagers: ['SecondaryTransactionManagers'],
		LenderRelationsManagers: ['LenderRelationsManagers'],
	},
	ExcludedLenders: (dealGuid: Guid | undefined) => ['Deal Excluded Lenders', dealGuid],
	DataRoom: {
		Root: (dataRoomGuid: Guid | undefined) => ['Data Room', dataRoomGuid],
		Confirmation: (dataRoomGuid: Guid | undefined) => ['Data Room Confirmation', dataRoomGuid],
		LoanApplication: (dataRoomGuid: Guid | undefined) => ['Loan Application', dataRoomGuid],
		Summary: (dataRoomGuid: Guid | undefined) => ['Data Room Summary', dataRoomGuid],
		Folders: (dataRoomGuid: Guid | undefined) => ['Data Room Folders', dataRoomGuid],
		FolderHierarchy: (dataRoomGuid: Guid | undefined) => ['Data Room Folder Hierarchy', dataRoomGuid],
		SendDocumentLink: (dataRoomGuid: Guid | undefined, linkGuid: Guid | undefined) => [
			'Document Link',
			dataRoomGuid,
			linkGuid,
		],
		SendFolderLink: (dataRoomGuid: Guid | undefined, linkGuid: Guid | undefined) => [
			'Folder Link',
			dataRoomGuid,
			linkGuid,
		],
		AccessLogs: (dataRoomGuid: Guid | undefined, userGuid: Guid | null | undefined) => [
			'Access Logs',
			dataRoomGuid,
			userGuid,
		],
		CreateDataRoomAccessedLog: (dataRoomGuid: Guid | undefined) => ['Create Data Room Access Logs', dataRoomGuid],
		ActivityLogs: (
			dataRoomGuid: Guid | undefined,
			userGuid: Guid | null | undefined,
			name: string | null | undefined,
			page: number | null | undefined
		) => ['Activity Logs', dataRoomGuid, userGuid, name, page],
		DownloadRequests: (dataRoomGuid: Guid | undefined, userGuid: Guid | null | undefined) => [
			'Download Requests',
			dataRoomGuid,
			userGuid,
		],
		OtherActiveDeals: (dataRoomGuid: Guid | undefined) => ['Other Active Deals', dataRoomGuid],
		LenderSummaryReport: (dataRoomGuid: Guid | undefined) => ['Lender Summary Report', dataRoomGuid],
		ActiveLenderSummaryReport: (dataRoomGuid: Guid | undefined) => ['Active Lender Summary Report', dataRoomGuid],
		LenderStatusBar: (dataRoomGuid: Guid | undefined) => ['Lender Status Bar', dataRoomGuid],
	},
	TermSheets: {
		Specific: (dataRoomGuid: Guid | undefined, termSheetGuid: Guid | null | undefined) => [
			'Term Sheet',
			dataRoomGuid,
			termSheetGuid,
		],
		Revision: (
			dataRoomGuid: Guid | undefined,
			termSheetGuid: Guid | null | undefined,
			revisionGuid: Guid | null | undefined
		) => ['Term Sheet Revision', dataRoomGuid, termSheetGuid, revisionGuid],
		RevisionMatchingParams: (
			dataRoomGuid: Guid | undefined,
			termSheetGuid: Guid | null | undefined,
			revisionGuid: Guid | null | undefined
		) => ['Term Sheet Revision Matching Params', dataRoomGuid, termSheetGuid, revisionGuid],
		RevisionsByGuid: (dataRoomGuid: Guid | undefined, termSheetGuid: Guid | null | undefined) => [
			'Term Sheet Revisions',
			dataRoomGuid,
			termSheetGuid,
		],
		FacilityFees: (
			dataRoomGuid: Guid | undefined,
			termSheetGuid: Guid | null | undefined,
			revisionGuid: Guid | null | undefined,
			facilityGuid: Guid | null | undefined
		) => ['Term Sheet Facility Fees', dataRoomGuid, termSheetGuid, revisionGuid, facilityGuid],
		FacilityCollateral: (
			dataRoomGuid: Guid | undefined,
			termSheetGuid: Guid | null | undefined,
			revisionGuid: Guid | null | undefined,
			facilityGuid: Guid | null | undefined
		) => ['Term Sheet Facility Collateral', dataRoomGuid, termSheetGuid, revisionGuid, facilityGuid],
		Revisions: (dataRoomGuid: Guid | undefined) => ['Revisions', dataRoomGuid],
		List: (dataRoomGuid: Guid | undefined) => ['Term Sheets', dataRoomGuid],
		Comparison: (dataRoomGuid: Guid | undefined) => ['Term Sheet Comparison', dataRoomGuid],
		HistoricalBankRate: (revisionGuid: Guid | null | undefined, rateType: BaseRateTypes | null | undefined) => [
			'Historical Bank Rate',
			revisionGuid,
			rateType,
		],
	},
	DataRoomUsers: {
		Root: (dataRoomGuid: Guid | undefined) => ['Data Room Users', dataRoomGuid],
		GetByUser: (dataRoomGuid: Guid | undefined, userGuid: Guid | null | undefined) => [
			'Room User By Guid',
			dataRoomGuid,
			userGuid,
		],
		LenderByUser: (dataRoomGuid: Guid | undefined, userGuid: Guid | null | undefined) => [
			'Data Room User By Guid',
			dataRoomGuid,
			userGuid,
		],
		TeamMemberByUser: (dataRoomGuid: Guid | undefined, userGuid: Guid | null | undefined) => [
			'Data Room Team Member By User Guid',
			dataRoomGuid,
			userGuid,
		],
		TeamMembersByRoom: (dataRoomGuid: Guid | undefined) => ['Data Room Team Members', dataRoomGuid],
		Notes: (dataRoomGuid: Guid | undefined, dataRoomUserGuid: Guid | null | undefined) => [
			'Data Room Notes',
			dataRoomGuid,
			dataRoomUserGuid,
		],
		TeamMembers: (dataRoomGuid: Guid | undefined, dataRoomUserGuid: Guid | null | undefined) => [
			'Contact Team Members',
			dataRoomGuid,
			dataRoomUserGuid,
		],
		OptOut: (dataRoomGuid: Guid | undefined, dataRoomUserGuid: Guid | null | undefined) => [
			'Opt Out Details',
			dataRoomGuid,
			dataRoomUserGuid,
		],
		Email: (dataRoomGuid: Guid | undefined, dataRoomUserGuid: Guid | null | undefined) => [
			'Data Room Emails',
			dataRoomGuid,
			dataRoomUserGuid,
		],
		Invite: (dataRoomGuid: Guid | undefined, dataRoomUserGuid: Guid | null | undefined) => [
			'Invite Model',
			dataRoomGuid,
			dataRoomUserGuid,
		],
	},
	DataRoomDiligenceRequests: {
		Root: (dataRoomGuid: Guid | undefined) => ['Data Room Diligence Requests', dataRoomGuid],
		Lender: (dataRoomGuid: Guid | undefined) => ['Lender Diligence Requests', dataRoomGuid],
		Uploads: (dataRoomGuid: Guid | undefined) => ['Diligence Request Uploads', dataRoomGuid],
	},
	ThirdPartyContacts: {
		Root: (dataRoomGuid: Guid | undefined) => ['Third Party Contacts Contacts', dataRoomGuid],
	},
	DataRoomContacts: {
		Root: (dataRoomGuid: Guid | undefined) => ['Data Room Contacts', dataRoomGuid],
		BorrowerParticipants: (dataRoomGuid: Guid | undefined) => ['Borrower Participants', dataRoomGuid],
	},
	DataRoomPartnerContacts: {
		Root: (guid: Guid | undefined) => ['Data Room Partner Contacts', guid],
	},
	LenderInvites: {
		Root: (dataRoomGuid: Guid | undefined) => ['Lender Invites', dataRoomGuid],
	},
	Teasers: {
		Root: (dataRoomGuid: Guid | undefined) => ['Teasers', dataRoomGuid],
		Preview: (dataRoomGuid: Guid | undefined) => ['Teaser Preview', dataRoomGuid],
		Files: (dataRoomGuid: Guid | undefined) => ['Teaser Files', dataRoomGuid],
	},
	Calls: {
		Root: (dataRoomGuid: Guid | undefined) => ['Calls', dataRoomGuid],
		Lender: (dataRoomGuid: Guid | undefined, profileGuid: Guid | null | undefined) => [
			'Lender Calls',
			dataRoomGuid,
		],
	},
	Deal: (dealGuid: Guid | undefined) => ['Deal', dealGuid],
	RelatedDeals: (dealGuid: Guid | undefined) => ['Related Deals', dealGuid],
	DebtSchedule: (dealGuid: Guid | undefined) => ['Debt Schedule', dealGuid],
	Company: (companyGuid: Guid | undefined) => ['Company', companyGuid],
	CompanyContacts: {
		Root: (companyGuid: Guid | undefined) => ['Company Contacts', companyGuid],
		FromDataRoom: (dataRoomGuid: Guid | undefined) => ['Company Contacts', dataRoomGuid],
		SingleForDataRoom: (dataRoomGuid: Guid | undefined) => ['Data Room Company Contact', dataRoomGuid],
	},
	Milestones: {
		Root: (dataRoomGuid: Guid | undefined) => ['Milestone Report', dataRoomGuid],
		LenderReport: (dataRoomGuid: Guid | undefined, bankContactGuid: Guid | null | undefined) => [
			'Lender Milestone Report',
			dataRoomGuid,
			bankContactGuid,
		],
		DirectConnect: {
			Root: (dataRoomGuid: Guid | undefined) => ['Direct Connect Milestone Report', dataRoomGuid],
			LenderReport: (dataRoomGuid: Guid | undefined, bankContactGuid: Guid | null | undefined) => [
				'Lender Direct Connect Milestone Report',
				dataRoomGuid,
				bankContactGuid,
			],
		},
	},
	Allocation: (dealGuid: Guid | undefined) => ['Deal Request Allocation', dealGuid],
	AllocationRealEstates: (dealGuid: Guid | undefined) => ['Deal Request Allocation Real Estates', dealGuid],
	Matching: {
		Get: (dealGuid: Guid | undefined) => ['Matching', dealGuid],
		Stats: (dealGuid: Guid | undefined) => ['Matching Stats', dealGuid],
		Tranches: (dealGuid: Guid | undefined) => ['Matching Tranches', dealGuid],
		Preferences: (dealGuid: Guid | undefined) => ['Matching Preferences', dealGuid],
		OutputAnalysis: (dealGuid: Guid | undefined) => ['Output Analysis', dealGuid],
		Params: (dealGuid: Guid | undefined) => ['Matching Params', dealGuid],
		Processing: (dealGuid: Guid | undefined) => ['Matching Processing', dealGuid],
		Lenders: (
			dealGuid?: string,
			mode?: number,
			tier1?: number,
			finderFee?: boolean,
			structure?: number | null,
			filterType?: number,
			matchMode?: number | null
		) => ['Matching Lenders', dealGuid, mode, tier1, finderFee, structure, filterType, matchMode],
		TermSheets: (dealGuid?: string, structure?: number | null, tier1?: number | null) => [
			'Matching Term Sheets',
			dealGuid,
			structure,
			tier1,
		],
		UnavailableReasons: (dealGuid?: string, structureTranche?: number | null, tier1BankType?: number | null) => [
			'Matching Tranche Reasons',
			dealGuid,
			structureTranche,
			tier1BankType,
		],
	},
	Documents: {
		Root: (dataRoomGuid: Guid | undefined, folderGuid: Guid | undefined) => ['Data Room Documents'],
		History: (dataRoomGuid: Guid | undefined, documentGuid: Guid | undefined) => ['Document History'],
		Folder: (dataRoomGuid: Guid | undefined, folderGuid: Guid | undefined) => ['Document Folder'],
		Deleted: (dataRoomGuid: Guid | undefined) => ['Deleted Documents'],
		All: (dataRoomGuid: Guid | undefined) => ['All Documents'],
	},
	ControlledObjects: (userGuid: Guid | undefined) => ['Controlled Objects', userGuid],
	Lookups: {
		LenderDeclineReasons: ['Lender Decline Reasons'],
		ActiveDataRoomUsers: (dataRoomGuid: Guid | undefined) => ['Active Data Room Users', dataRoomGuid],
		ActiveDataRoomLenders: (dataRoomGuid: Guid | undefined) => ['Active Data Room Lenders', dataRoomGuid],
		FinancialCovenantTypes: ['Financial Covenant Types'],
		TermSheetFees: ['Term Sheet Fees'],
		Timezones: ['Timezones'],
		ConditionTypes: ['Condition Types'],
		ApplicationSettings: ['Application Settings'],
	},
	Product: (dealGuid: Guid | undefined) => ['Product', dealGuid],
	Nda: {
		Standard: (dataRoomGuid: string | undefined, companyName: string | undefined) => [
			'dataRoomNda',
			'standard',
			dataRoomGuid,
			companyName,
		],
	},
	LenderNda: {
		Root: (dataRoomGuid: Guid | undefined) => ['Lender Nda', dataRoomGuid],
		Access: (dataRoomGuid: Guid | undefined) => ['Access Lender Nda', dataRoomGuid],
		Active: (dataRoomGuid: Guid | undefined) => ['Active Lender Nda', dataRoomGuid],
		Signed: (dataRoomGuid: Guid | undefined) => ['Signed Lender Nda', dataRoomGuid],
		Available: (dataRoomGuid: Guid | undefined, roomUserGuid: Guid | undefined) => [
			'Available Lender Ndas',
			dataRoomGuid,
			roomUserGuid,
		],
	},
	Banks: {
		BankDealProfile: (bankGuid: Guid | undefined, bankContactGuid: Guid | undefined) => [
			'Bank Contact Deal Profile',
		],
		ActionsTaken: (bankGuid: Guid | undefined) => ['Bank Actions Taken', bankGuid],
	},
	Lenders: {
		BankDealProfile: (dataRoomGuid: Guid | undefined, dataRoomUserGuid: Guid | undefined) => ['Bank Deal Profile'],
	},
	Integrations: {
		Config: () => ['Integration Config'],
	},
};
